<form *ngIf="offer$ | async as OfferGroupDetails; else loading" [formGroup]="formGroup" novalidate>
    <mat-card appearance="outlined">
        <mat-card-content fxLayout="column">
            <div fxLayout="row wrap" fxLayoutAlign="space-between">
                <div class="d-flex">
                    <h2>{{formGroup.controls.Detail.controls.Name.value == '' ? "Offer Group" :
                        formGroup.controls.Detail.controls.Name.value}}</h2>
                </div>
            </div>

            <div formGroupName="Detail" class="offer-details-form">
                <mat-accordion class="OfferDetails" multi>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Offer Group Details</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                            <div fxLayout="column" fxFlex="auto" class="marginTop">
                                <mat-form-field appearance="outline">
                                    <mat-label>Offer Group Name</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="Name" />
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Name.hasError('required')">
                                        Offer Group Name is required
                                    </mat-error>
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Name.status=='INVALID'">
                                        {{formGroup.controls.Detail.controls.Name.errors!['maxlength'] && 'Maximum
                                        length can be' +
                                        formGroup.controls.Detail.controls.Name.errors!['maxlength']['requiredLength'] +
                                        '.'}}
                                    </mat-error>
                                </mat-form-field>

                                <div fxLayout="row" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                                    <mat-form-field appearance="outline" fxFlex>
                                        <mat-label>Start Date</mat-label>
                                        <input matInput [matDatepicker]="startDatePicker" formControlName="StartDate"
                                            [disabled]="!canEdit()" (dateChange)="onDateCommitted()">
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.StartDate.hasError('required')">
                                            Start date is required.
                                        </mat-error>
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.StartDate.status=='INVALID'">
                                            {{formGroup.controls.Detail.controls.StartDate.errors!['matDatepickerMax']
                                            && 'Start Date exceeded maximum year.'}}
                                        </mat-error>
                                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"
                                            [disabled]="!canEdit()">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #startDatePicker [disabled]="!canEdit()"></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" fxFlex>
                                        <mat-label>End Date</mat-label>
                                        <input [disabled]="!canEdit()" matInput [matDatepicker]="endDatePicker"
                                            formControlName="EndDate" (dateChange)="onDateCommitted()">
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.EndDate.hasError('required')">
                                            End date is required.
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.controls.Detail.controls.EndDate.status=='INVALID'">
                                            {{formGroup.controls.Detail.controls.EndDate.errors!['matDatepickerMax'] &&
                                            'End Date exceeded maximum year.'}}
                                        </mat-error>
                                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"
                                            [disabled]="!canEdit()"></mat-datepicker-toggle>
                                        <mat-datepicker #endDatePicker [disabled]="!canEdit()"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <mat-form-field appearance="outline" fxFlex="33">
                                    <mat-label>Headline</mat-label>
                                    <textarea [readonly]="!canEdit()" matInput type="text"
                                        formControlName="Headline"></textarea>
                                </mat-form-field>

                                <mat-form-field appearance="outline" fxFlex>
                                    <mat-label>Body Copy</mat-label>
                                    <textarea [readonly]="!canEdit()" matInput type="text"
                                        formControlName="BodyCopy"></textarea>
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Disclaimer</mat-label>
                                    <textarea [readonly]="!canEdit()" matInput type="text"
                                        formControlName="Disclaimer"></textarea>
                                </mat-form-field>
                            </div>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <mat-form-field appearance="outline" fxFlex="33">
                                <mat-label>Comment</mat-label>
                                <textarea [readonly]="!canEdit()" matInput type="text"
                                    formControlName="ClientComment"></textarea>
                            </mat-form-field>

                            <div fxFlex="33">
                                <app-pr1-offer-tags [placeholder]="'Associate Tag...'" [label]="'Offer Tags'"
                                    [selectedTagIds]="offerTagIds" (tagRemoved)="removeTag($event)"
                                    (tagAdded)="addTag($event)" [offerTagsFormControl]="tagCtrl"
                                    (tagSelectedEmitter)="tagSelected($event)">
                                </app-pr1-offer-tags>
                            </div>

                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label class="pl-2">Categories</mat-label>
                                <mat-select formControlName="ProductCategoryIds" multiple #select1
                                    (closed)="clearSearch()">
                                    <mat-select-trigger>
                                        <mat-chip-set>
                                            <mat-chip
                                                *ngFor="let category of formGroup.controls.Detail.controls.ProductCategoryIds.value"
                                                [removable]="true" (removed)="onCategoryRemoved(category)">
                                                {{ category?.ProductCategoryName }}
                                                <mat-icon matChipRemove>cancel</mat-icon>
                                            </mat-chip>
                                        </mat-chip-set>
                                    </mat-select-trigger>
                                    <div fxLayout="row">
                                        <div class="search-input-group">
                                            <mat-icon matPrefix>search</mat-icon>
                                            <input placeholder="Search Categories" matInput [formControl]="categoryCtrl"
                                                class="mat-select-search-input" #searchSelectInput />
                                            <button mat-icon-button aria-label="Clear" class="mat-select-search-clear"
                                                (click)="clearData()">
                                                <mat-icon *ngIf="searchSelectInput.value">close</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <mat-option *ngFor="let category of filteredCategory | async" [value]="category"
                                        (click)="updateSelectedItems(select1, category)">
                                        {{category?.ProductCategoryName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Target Url</mat-label>
                                <input [readonly]="!canEdit()" matInput type="text" formControlName="TargetURL" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.TargetURL.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.TargetURL.errors!['maxlength'] && 'Maximum
                                    length can be
                                    '+formGroup.controls.Detail.controls.TargetURL.errors!['maxlength']['requiredLength']+'.
                                    '}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="33" *ngIf="offerId != '0'">
                                <mat-label>Id</mat-label>
                                <input [readonly]="!canEdit()" matInput formControlName="Id" readonly>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Client Key</mat-label>
                                <input [readonly]="!canEdit()" matInput type="text" formControlName="ClientKey" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.hasError('required')">
                                    Client key is required
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.ClientKey.errors!['maxlength'] && 'Maximum
                                    length can be ' +
                                    formGroup.controls.Detail.controls.ClientKey.errors!['maxlength']['requiredLength']
                                    + '.'}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Rank</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="Rank" (input)="onRankInput($event)" (blur)="onRankCommitted()" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.Rank.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.Rank.errors!['max'] && 'Maximum number can be '
                                    + formGroup.controls.Detail.controls.Rank.errors!['max']['max'] + '. '}}
                                    {{formGroup.controls.Detail.controls.Rank.errors!['min'] && 'Minimum required number
                                    can be' + formGroup.controls.Detail.controls.Rank.errors!['min']['min'] + '. '}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Badge</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="BadgeAssetId">
                                    <mat-option *ngFor="let item of assetsforBadge" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <img *ngIf="item?.FileName && assetsUrl$ | async as assetsUrl"
                                            class="badge-option-image" [src]="getImageSrc(assetsUrl, item)"
                                            alt="Offer image">
                                        <span>{{item?.AssetName}}</span>
                                    </mat-option>
                                    <mat-option [value]="noneValue">None</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="33">
                                <mat-label>Offer Type</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="OfferTypeId"
                                    (selectionChange)="onOfferTypeSelectionChange($event)"
                                    (closed)="onOfferTypePanelClosed()">
                                    <mat-option *ngFor="let item of offertypes" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <img *ngIf="item?.Detail?.FileName" class="badge-option-image"
                                            src="{{assetsUrl$ | async}}/{{item?.Detail?.FileName}}" />
                                        {{item?.OfferTypeName}}
                                    </mat-option>
                                    <mat-option [value]="noneValue">None</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Loyalty Indicator</mat-label>
                                <input [readonly]="!canEdit()" matInput type="text" formControlName="LoyaltyIndicator" />
                            </mat-form-field>

                        </div>

                    </mat-expansion-panel>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Print-Related Details</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <mat-form-field appearance="outline" fxFlex="33">
                                <mat-label>Page Number</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="PrintPageId">
                                    <mat-option *ngFor="let item of printPagesList" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <span>{{item?.PageFrom}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="33">
                                <mat-label>Position</mat-label>
                                <input [readonly]="!canEdit() || !formGroup['controls'].Detail['controls']['PrintPageId'].value" matInput type="number" formControlName="Position" />
                            </mat-form-field>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Pricing</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="column" class="paddingTop">
                            <div fxFlex="100">
                                <app-offer-pricing-form #pricingForm [canEdit]="canEdit()" [offerTypeId]="getSelectedOfferTypeId()"
                                    [offertypes]="offertypes" [offerDetails]="offerResponse.Detail"
                                    (formValueChange)="onPricingFormValueChange($event)"
                                    (formValidityChange)="onPricingFormValidityChange($event)">
                                </app-offer-pricing-form>
                            </div>
                        
                            <div fxLayout="row wrap" fxLayoutGap="16px">
                                <mat-form-field appearance="outline" fxFlex="33">
                                    <mat-label>And Up</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="AndUp" />
                                </mat-form-field>
                        
                                <mat-form-field appearance="outline" fxFlex="33">
                                    <mat-label>Language</mat-label>
                                    <mat-select [disabled]="!canEdit()" formControlName="Language">
                                    <mat-option *ngFor="let language of languages" [value]="language" class="badge-dropdown">{{language}}</mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                        
                                <mat-form-field appearance="outline" fxFlex="auto">
                                    <mat-label>Country</mat-label>
                                    <mat-select [disabled]="!canEdit()" formControlName="Country">
                                    <mat-option *ngFor="let country of countries" [value]="country" class="badge-dropdown">{{country}}</mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                        
                                <mat-form-field appearance="outline" fxFlex="33">
                                    <mat-label>Currency</mat-label>
                                    <mat-select [disabled]="!canEdit()" formControlName="Currency">
                                    <mat-option *ngFor="let currency of currencies" [value]="currency" class="badge-dropdown">{{currency}}</mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Additional Discounts</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Reward Amount</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="RewardAmount"
                                    pattern="\d{1,5}" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardAmount.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardAmount.errors!['max'] && 'Maximum number
                                    can be '+formGroup.controls.Detail.controls.RewardAmount.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.RewardAmount.errors!['min'] && 'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.RewardAmount.errors!['min']['min']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardAmount.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="33">
                                <mat-label>Reward Quantity</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="RewardQuantity"
                                    pattern="\d{1,5}" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardQuantity.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardQuantity.errors!['max'] && 'Maximum
                                    number can be
                                    '+formGroup.controls.Detail.controls.RewardQuantity.errors!['max']['max']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardQuantity.errors!['min'] && 'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.RewardQuantity.errors!['min']['min']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardQuantity.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="33">
                                <mat-label>Reward Spend</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="RewardSpend"
                                    pattern="\d{1,5}" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardSpend.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardSpend.errors!['max'] && 'Maximum number
                                    can be '+formGroup.controls.Detail.controls.RewardSpend.errors!['max']['max']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardSpend.errors!['min'] && 'Minimum required
                                    number can be
                                    '+formGroup.controls.Detail.controls.RewardSpend.errors!['min']['min']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardSpend.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Additional Discount Amount</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountAmount" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountAmount.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['min']['min']+'.
                                    '}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Additional Discount Quantity</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountQuantity" pattern="\d{1,5}" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountQuantity.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['min']['min']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['pattern']
                                    && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Additional Discount Amount 2</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountAmount2" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountAmount2.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['min']['min']+'.
                                    '}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Additional Discount Quantity 2</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountQuantity2" pattern="\d{1,5}" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['min']['min']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['pattern']
                                    && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Additional Discount Amount 3</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountAmount3" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountAmount3.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['min']['min']+'.
                                    '}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="auto">
                                <mat-label>Additional Discount Quantity 3</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountQuantity3" pattern="\d{1,5}" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['min']['min']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['pattern']
                                    && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </mat-expansion-panel>

                    <app-dynamic-fields-section
+                        *ngIf="(customFields$ | async)?.length"
                        [formGroup]="getCustomFieldsGroup()"
                        [customFields$]="customFields$">
                    </app-dynamic-fields-section>
                </mat-accordion>
            </div>
        </mat-card-content>
        <mat-card-actions class="card-footer-actions" fxLayout="row"
            [fxLayoutAlign]="offerId != '0' && OfferGroupDetails?.Detail?.OfferVariantName == 'Base' ?'space-between':'end'">
            <button appAuthorizeControl="edit||offermang" mat-raised-button type="button" color="warn"
                (click)="deleteRecord()"
                *ngIf="offerId != '0' && readOnlyMode != true">
                Delete
            </button>
            <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" fxLayoutAlign="end">
                <button class="btn-right" mat-stroked-button type="button" (click)="cancel()">
                    <span *ngIf="canEdit()">Cancel</span>
                    <span *ngIf="!canEdit()">Close</span>
                </button>
                <button *ngIf="canEdit()" class="btn-right" mat-raised-button type="button" (click)="save()"
                    [disabled]="formGroup.invalid || !isPricingFormValid" color="accent">
                    Save
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</form>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
